import { BaseService } from "./base.service";
import {
	IEvaluationSupportingDocument,
	ISupportingDocument,
} from "models/EvaluationSupportingDocumentModel";

class EvaluationSupportingDocumentServiceInternal extends BaseService {
	getEvaluationSupportingDocumentItemList = async (
		evaluationItemId: number
	): Promise<IEvaluationSupportingDocument[]> =>
		this.callApi<IEvaluationSupportingDocument[]>(
			`EvaluationSupportingDocumentItem/GetAll/${evaluationItemId}`,
			"GET"
		);

	getAllEvaluationSupportingDocumentList = async (): Promise<
		ISupportingDocument[]
	> =>
		this.callApi<ISupportingDocument[]>(
			`EvaluationSupportingDocument/GetAll`,
			"GET"
		);

	saveEvaluationSupportingDocumentItem = async (model: {
		evaluationItemId: number;
		evaluationSupportingDocument: string;
	}): Promise<number> =>
		this.callApi<number>(
			`EvaluationSupportingDocumentItem/Save`,
			"POST",
			undefined,
			model
		);

	saveEvaluationSupportingDocument = async (model: {
		name: string;
	}): Promise<number> =>
		this.callApi<number>(
			`EvaluationSupportingDocument/Save`,
			"POST",
			undefined,
			model
		);

	deleteEvaluationSupportingDocumentItem = async (
		evaluationSupportingDocumentId: number
	): Promise<undefined> =>
		this.callApi<undefined>(
			`EvaluationSupportingDocumentItem/Delete/${evaluationSupportingDocumentId}`,
			"DELETE"
		);

	deleteEvaluationSupportingDocument = async (
		evaluationSupportingDocumentId: number
	): Promise<undefined> =>
		this.callApi<undefined>(
			`EvaluationSupportingDocument/Delete/${evaluationSupportingDocumentId}`,
			"DELETE"
		);
}

export const EvaluationSupportingDocumentService =
	new EvaluationSupportingDocumentServiceInternal();
